<template>
  <div
    class="flex flex-col-reverse md:gap-[24px] gap-[10px] sm:gap-0 sm:flex-row sm:justify-between sm:items-center sm:py-[4px]"
    data-test-id="estate-breadcrumb"
  >
    <div class="flex gap-[8px] items-center mt-[0px]">
      <span v-html="estatePlan" class="flex items-center"></span>
      <h1
        class="md:text-[16px] text-[13px] font-medium text-btnActive font-just"
        >{{ displayTitle }}</h1
      >
    </div>
    <div class="flex flex-wrap items-center gap-2 sm:gap-3 sm:flex-nowrap">
      <span
        v-html="backArrow({ width: '24', height: '25' })"
        class="md:hidden bg-white w-[24px] h-[24px] rounded-full flex items-center justify-center custom-border cursor-pointer flex-shrink-0 mr-auto"
        @click="handleBackClick"
      ></span>
      <div
        class="lg:ml-auto md:ml-auto sm:ml-auto flex items-center justify-center py-[6px] xs:py-[8px] px-[8px] xs:px-[12px] rounded-[50px] bg-lightWhite/35 w-auto h-auto gap-[8px] xs:gap-[12px] custom-border sm:!border-none cursor-pointer"
        @click="handleButtonClick"
      >
        <BaseButton
          class="!bg-white !py-[4px] sm:!py-[8px] !px-[12px] xs:!px-[16px] !rounded-[58.874px] !flex !items-center !justify-center md:!h-[40px] !h-[25px]"
        >
          <span
            class="!flex !items-center !text-btnActive font-just text-[14px] sm:text-[16px] [@media(max-width:360px)]:text-[12px]"
          >
            <span class="ultra:text-[16px] !font-light leading-normal">
              {{ buttonLabelNormal }}
            </span>
            <span class="ml-1 !font-medium laptop:!font-semibold">{{
              buttonLabelBold
            }}</span>
          </span>
        </BaseButton>
        <span
          v-if="isMobile"
          v-html="estateSkip({ width: '25', height: '25' })"
          class="flex justify-center items-center"
        ></span>
        <span
          v-else
          v-html="estateSkip({ width: '40', height: '40' })"
          class="flex-shrink-0 justify-center items-center"
        ></span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { estatePlan, estateSkip, backArrow } from "@/utils/commonSvg";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { onMounted, onBeforeUnmount, ref, computed } from "vue";

const { t } = useI18n();

// Props for dynamic labels and navigation
const props = defineProps({
  buttonLabelNormal: {
    type: String,
    required: true,
  },
  buttonLabelBold: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: null,
  },
  routePath: {
    type: String,
    default: null,
  },
});
const displayTitle = computed(() => props.title || t('estatePlanLabels.buildingPlan'));
const isMobile = ref(false);

const router = useRouter();
const emit = defineEmits(["buttonClick"]);

// Handle main button click
function handleButtonClick() {
  if (props.routePath) {
    router.push(props.routePath);
  }
}

// Handle back navigation
function handleBackClick() {
  router.go(-1);
}

onMounted(() => {
  checkIsMobile();
  window.addEventListener("resize", checkIsMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkIsMobile);
});
function checkIsMobile() {
  isMobile.value =
    window.innerWidth < 768 ||
    "ontouchstart" in window ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
}
</script>
<style scoped>
.custom-border {
  border: 0.2px solid var(--tw-border-color, #8a9798);
}
</style>
